import Footer from "../layouts/footer/Footer";
import IntroSection from "../layouts/IntroSection/IntroSection";
import NucleappProduct from "../layouts/NucleappProduct/NucleappProduct";
import Products from "../layouts/Products/Products";
import VisionAndMission from "../layouts/VisionAndMission/VisionAndMission";
import { useEffect } from "react";
import logo from "../../assets/logo.svg";

export default function Home() {
  useEffect(() => {
    document.title = "StartAppify";
    let link = document.querySelector("link[rel='icon']");

    link.href = logo;
  }, []);

  return (
    <main>
      <IntroSection />
      <NucleappProduct />
      <VisionAndMission />
      <Products />
      <Footer />
    </main>
  );
}
